/* dbo-lc01.js: generated by build.py from src/lc01.html. */
/* LC01 behaviour: CTA links + UTM passthrough, dates, calendar, comparison chips, carousel, sticky bar. */
(function () {
  var root = document.querySelector('.lc01');
  if (!root) return;

  /* Links. Each CTA carries its position in utm_content (brief). The ad's own UTMs from the landing URL
     are forwarded on top, except utm_content, which is kept as ad_content so the position survives. */
  var incoming = new URLSearchParams(window.location.search);
  root.querySelectorAll('a[data-cta]').forEach(function (a) {
    var u = new URL(a.getAttribute('href'));
    u.searchParams.set('utm_source', 'meta');
    u.searchParams.set('utm_medium', 'paid');
    incoming.forEach(function (v, k) {
      if (k === 'utm_content') { u.searchParams.set('ad_content', v); return; }
      u.searchParams.set(k, v);
    });
    u.searchParams.set('utm_content', a.getAttribute('data-cta'));
    a.href = u.toString();
  });

  /* Dates, noon-anchored against DST edges. */
  var d0 = new Date(); d0.setHours(12, 0, 0, 0);
  function add(n) { var d = new Date(d0); d.setDate(d.getDate() + n); return d; }
  function longD(d) { return d.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' }); }
  function md(d) { return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric' }); }
  /* Byline date = the visitor's today minus 3 days (CEO 2026-09-25). */
  var pub = add(-3).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  root.querySelectorAll('.js-pub').forEach(function (el) { el.textContent = pub; });

  /* FIG. 4 calendar: every row counted from the visitor's date (CEO 2026-09-25). */
  root.querySelectorAll('.js-d14').forEach(function (el) { el.textContent = longD(add(14)); });
  var cal = root.querySelector('.js-cal');
  if (cal) {
    var rows = [
      { unit: 'DAY', num: '1', date: 'Today', out: 'Run the check. First scoop.' },
      { unit: 'WEEK', num: '2', date: longD(add(14)), out: 'Fresher breath. Run the check again.' },
      { unit: 'WEEKS', num: '4 to 6', small: true, date: md(add(28)) + ' to ' + md(add(42)), out: 'Teeth you can see changing.' },
      { unit: 'DAY', num: '60', date: longD(add(60)), out: 'Your 60 days are up. Keep going, or every cent back.' },
      { unit: 'DAY', num: '90', date: longD(add(90)), out: 'Your dog back on the couch, right next to you.' }
    ];
    var html = '';
    rows.forEach(function (r, i) {
      var rule = i < rows.length - 1 ? ' rule' : '';
      html += '<div class="cal-row' + rule + '"><div class="cal-k"><div class="cal-u">' + r.unit + '</div><div class="cal-n' + (r.small ? ' sm' : '') + '">' + r.num + '</div></div>' +
        '<div class="cal-t"><div class="d">' + r.date + '</div><div>' + r.out + '</div></div></div>';
    });
    cal.innerHTML = html;
  }

  /* Check marks. CHK = white disc (DE-01 column), CHKO = outlined disc (category column). */
  var tick = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1A2A3D" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
  root.querySelectorAll('.chk').forEach(function (el) { el.textContent = ''; el.insertAdjacentHTML('beforeend', tick); el.setAttribute('aria-label', 'Yes'); el.setAttribute('role', 'img'); });

  /* Mobile comparison chips. */
  var names = ['Dental Chews', 'Water Additives', 'Brushing', 'Other Powders'];
  var sels = root.querySelectorAll('.m-sel');
  function pick(i) {
    root.querySelectorAll('.chip').forEach(function (c) { c.setAttribute('aria-pressed', String(+c.getAttribute('data-i') === i)); });
    var nm = root.querySelector('.js-selname'); if (nm) nm.textContent = names[i];
    sels.forEach(function (s) {
      var v = JSON.parse(s.getAttribute('data-cells'))[i];
      s.innerHTML = v === true ? '<span class="chk" role="img" aria-label="Yes">' + tick + '</span>' : '<span></span>';
      if (v !== true) s.firstChild.textContent = v;
    });
  }
  root.querySelectorAll('.chip').forEach(function (c) { c.addEventListener('click', function () { pick(+c.getAttribute('data-i')); }); });
  pick(0);

  /* Carousel progress + arrows. */
  var car = root.querySelector('.js-car'), thumb = root.querySelector('.js-thumb');
  function onCar() {
    if (!car || !thumb) return;
    var max = car.scrollWidth - car.clientWidth;
    var w = Math.min(1, car.clientWidth / car.scrollWidth);
    var p = max > 0 ? car.scrollLeft / max : 0;
    thumb.style.width = (w * 100).toFixed(2) + '%';
    thumb.style.left = (p * (1 - w) * 100).toFixed(2) + '%';
  }
  if (car) {
    car.addEventListener('scroll', onCar, { passive: true });
    root.querySelector('.js-prev').addEventListener('click', function () { car.scrollBy({ left: -car.clientWidth * 0.8, behavior: 'smooth' }); });
    root.querySelector('.js-next').addEventListener('click', function () { car.scrollBy({ left: car.clientWidth * 0.8, behavior: 'smooth' }); });
  }

  /* Sticky bar: shows once the bottom of item 1 has scrolled above the viewport top,
     hides while the close block or the footer is on screen. */
  var sticky = root.querySelector('.js-sticky'), m03 = root.querySelector('.js-m03'),
      closeEl = root.querySelector('.js-close'), foot = root.querySelector('.js-foot'), on = false;
  function vis(el) { if (!el) return false; var r = el.getBoundingClientRect(); return r.top < window.innerHeight && r.bottom > 0; }
  function onScroll() {
    var past = m03 ? m03.getBoundingClientRect().bottom < 0 : false;
    var s = past && !vis(closeEl) && !vis(foot);
    if (s !== on) {
      on = s;
      sticky.classList.toggle('on', s);
      sticky.setAttribute('aria-hidden', String(!s));
      var b = sticky.querySelector('a'); if (b) b.tabIndex = s ? 0 : -1;
    }
  }
  document.addEventListener('scroll', onScroll, { capture: true, passive: true });
  window.addEventListener('resize', function () { onScroll(); onCar(); });
  onScroll();
  setTimeout(onCar, 400);
})();
